import React from "react";
import {CANDIDATE_STATUS_NEW} from "../../../common/util/util-consts";
import Tooltip from "../../../common/components/tooltip";

export default function CandidateChecklistProgress({item}) {
    if (item.CandidateStatusID === CANDIDATE_STATUS_NEW) {
        return null;
    }

    const total = item.ChecklistTotal ?? 0;

    if (total === 0) return null;

    const completed = item.ChecklistCompleted ?? 0;
    const waiting = item.ChecklistWaiting ?? 0;
    const checklistProgress = total > 0 ? Math.round((completed / total) * 100) : 0;
    const waitingProgress = total > 0 ? Math.round((waiting / total) * 100) : 0;

    return (
        <Tooltip content={
            <div className="flex items-center gap-2 text-inverse">
                 <span className="font-medium">
                    {checklistProgress}%
                </span>

                <span>·</span>

                <span>
                    {completed}/{total} steps
                </span>

                {waiting > 0 && (
                    <span className="mr-2">· {waiting} waiting</span>
                )}
            </div>
        }>
            <div className="w-full text-sm">
                <div className="flex items-center gap-2">
                   <span className="font-medium text-emerald-600">
                        {checklistProgress}%
                    </span>

                    <span>·</span>

                    <span className="text-tm-gray-600">
                            {completed}/{total} steps
                    </span>

                    {waiting > 0 && (
                        <span className="mr-2 text-amber-600">· {waiting} waiting</span>
                    )}
                </div>

                <div
                    className="relative h-[6px] bg-tm-gray-300 rounded-full w-full"
                    // style={{width: `${checklistProgress}%`}}
                >
                    <div
                        className="absolute inset-y-0 h-[6px] bg-amber-400 rounded-full"
                        style={{width: `${checklistProgress + waitingProgress}%`}}
                    />

                    <div
                        className="absolute inset-y-0 h-[6px] bg-emerald-500 rounded-full"
                        style={{width: `${checklistProgress}%`}}
                    />
                </div>
            </div>
        </Tooltip>
    );
}
